import sagaReducerFactory from 'saga-reducer-factory';
import reservationActions from '../actions/reservationActions';
import {put, call, select} from 'redux-saga/effects';

const {handle, updateState, saga, reducer} = sagaReducerFactory({
  actionTypes: reservationActions.types,
  actionCreators: reservationActions.actions,
  initState: {reservation: {}, pending: false, error: null, newlyCanceled: false}
});

handle(reservationActions.types.GET_RESERVATION_REQUEST, function* ({restClient}, action) {
  yield put(updateState({pending: true}));

  try {
    const {ownerToken, restaurantId, reservationId} = action.payload;

    const reservation = yield call(restClient,
      `/organizations/${restaurantId}/reservations/${reservationId}?viewMode=customer`,
      'get',
      null,
      {type: 'Bearer', credentials: ownerToken}
    );

    yield put(updateState({reservation, error: null, pending: false}));
    yield put(reservationActions.actions.getReservationSuccess(reservation));
  } catch (error) {
    yield put(updateState({error, pending: false}));
    yield put(reservationActions.actions.getReservationFailure(error));
  }
});

handle(reservationActions.types.SET_RESERVATION_STATUS_REQUEST, function* ({restClient}, action) {
  yield put(updateState({pending: true, newlyCanceled: false}));
  const previousStatus = yield select(state => state.reservation.reservation.status);

  try {
    const {ownerToken, reservationId, comment, status} = action.payload;
    const restaurantId = yield select(state => state.organization.organization.id);

    const reservation = yield call(restClient,
      `/organizations/${restaurantId}/reservations/${reservationId}/${status}?as=customer`,
      'post',
      {comment},
      {type: 'Bearer', credentials: ownerToken}
    );

    // If reservation status has changed, and it's now canceled,
    // user should acknowledge this change.
    const newlyCanceled = (previousStatus !== reservation.status && reservation.status === 'canceled');

    yield put(updateState({reservation, error: null, pending: false, newlyCanceled}));
    yield put(reservationActions.actions.setReservationStatusSuccess(reservation));
  } catch (error) {
    yield put(updateState({error, pending: false}));
    yield put(reservationActions.actions.setReservationStatusFailure(error));
  }
});

handle(reservationActions.types.ACKNOWLEDGE_CANCELLATION, function* () {
  yield put(updateState({newlyCanceled: false}));
});

export default {saga, reducer};



// WEBPACK FOOTER //
// ./sagas/reservationSaga.js